import React from "react";
import { useNavigate } from "react-router-dom";

import {
	AIPowered,
	DataDriven,
	Efficiency,
	Fairness,
	Growth,
	OneClick,
	PersonalizedFeedback,
	RealTime,
	StreamlinedProcess,
	TailoredJob,
} from "../../../assets/icons/interface/interface";
import useIsLoggedIn from "../../../hooks/use-IsLoggedIn";
import { Button } from "../../JobsPage/components/Button";
import Header from "../../Profile/components/Header";
import Footer from "../Footer";

function AboutUsNewDesign() {
	const navigate = useNavigate();
	const isLoggedIn = useIsLoggedIn();

	return (
		<div className="bg-[#F8F9FA] leading-normal">
			<Header isLoggedIn={isLoggedIn} />
			<div className="relative">
				<img src="/images/about-us-banner.jpg" alt="About Us" className="w-full h-auto" />
				<div className="absolute inset-0 bg-[#007BFFB2] opacity-70" />
				<div className="absolute inset-0 flex flex-col items-center justify-center container max-w-[1243px] space-y-6">
					<h1 className="text-white line-clamp-2 text-[42px] font-bold text-center hidden md:block">
						Dproz is more than a job platform. It is a movement for opportunity.
					</h1>
					<div className="text-white hidden md:block text-xl font-normal text-center space-y-3">
						<div>At Dproz, we believe every young Tanzanian deserves a fair chance to build a good career.</div>
						<div>
							It does not matter where you come from. What matters is that you are ready to learn, ready to grow, and
							ready to contribute.
						</div>
						<div>
							But many people never get to see the right job for them. Job information is often hidden in private
							circles or buried on platforms that are hard to access.
						</div>
						<div>We are here to change that.</div>
					</div>
					<Button
						className="bg-white text-[#0A6FE2] hover:bg-white rounded-lg w-[281px] h-[59px]"
						onClick={() => {
							navigate("/register");
						}}
					>
						Start Your Journey Today
					</Button>
				</div>
			</div>
			<div className="py-8">
				<div className="container max-w-[1243px]">
					<div className="py-8 space-y-2">
						<div className="text-[34px] text-[#007BFF] font-bold text-center">Our Mission</div>
						<div className="text-2xl text-[#555555] font-normal text-center space-y-4">
							<p>To make job opportunities easy to find and open to everyone, in every part of Tanzania.</p>
							<p>
								<span className="font-bold">We are building tools that support both job seekers and employers:</span>
								<br />
								If you are a job seeker, Dproz helps you find jobs that match your skills and interests
								<br />
								If you are an employer, Dproz helps you find the right people faster and easier
							</p>
							<p>
								We are also building a community of Dependable Professionals — people who show up, do the work, and help
								each other grow.
							</p>
						</div>
					</div>
					<div className="flex flex-col md:flex-row gap-6">
						<div className="bg-white rounded-lg shadow p-8 flex-1">
							<div className="space-y-6">
								<div className="text-2xl font-bold">For Job Seekers</div>
								<div className="flex items-start gap-4">
									<TailoredJob />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">Tailored Job Recommendations</div>
										<div className="text-lg font-medium text-[#555555]">
											Receive opportunities that precisely match your skills and career goals.
										</div>
									</div>
								</div>
								<div className="flex items-start gap-4">
									<OneClick />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">One-Click Applications</div>
										<div className="text-lg font-medium text-[#555555]">
											Apply quickly without tedious forms, so you never miss out on a great opportunity.
										</div>
									</div>
								</div>
								<div className="flex items-start gap-4">
									<PersonalizedFeedback />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">Personalized Feedback</div>
										<div className="text-lg font-medium text-[#555555]">
											Enhance your resume with actionable insights that help you stand out.
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="bg-white rounded-lg shadow p-8 flex-1">
							<div className="space-y-6">
								<div className="text-2xl font-bold">For Employers</div>
								<div className="flex items-start gap-4">
									<AIPowered />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">AI-Powered Matching</div>
										<div className="text-lg font-medium text-[#555555]">
											Instantly identify top candidates—cutting manual resume screening time by hours.
										</div>
									</div>
								</div>
								<div className="flex items-start gap-4">
									<StreamlinedProcess />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">Streamlined Processes</div>
										<div className="text-lg font-medium text-[#555555]">
											Automate repetitive tasks like shortlisting and screening so your team can focus on strategic
											decisions.
										</div>
									</div>
								</div>
								<div className="flex items-start gap-4">
									<RealTime />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">Real-Time Collaboration</div>
										<div className="text-lg font-medium text-[#555555]">
											Our centralized dashboard eliminates endless emails and miscommunication, keeping your team
											aligned.
										</div>
									</div>
								</div>
								<div className="flex items-start gap-4">
									<DataDriven />
									<div className="space-y-1.5">
										<div className="text-xl font-semibold">Data-Driven Insights</div>
										<div className="text-lg font-medium text-[#555555]">
											Make smarter hiring decisions with actionable analytics that reduce costs and boost candidate
											quality.
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="bg-white py-8 mt-8">
				<div className="container max-w-[1243px]">
					<div className="space-y-2 py-8">
						<div className="text-center text-[34px] font-bold text-[#007BFF]">Why This Matters</div>
						<div className="text-center text-2xl font-normal text-[#555555] space-y-4">
							<p>
								<span className="font-bold">When job information is hard to access:</span>
								<br />
								Candidates miss out on opportunities
								<br />
								Employers struggle to find the right talent
								<br />
								Our country loses potential that could create value
							</p>
							<p>
								That is why Dproz is not just a platform. It is a growing movement to make sure no opportunity is
								wasted.
							</p>
						</div>
					</div>
					<div className="flex flex-col md:flex-row gap-6">
						{[
							{
								icon: <Efficiency />,
								title: "Efficiency",
								description: "Save time and reduce recruitment costs with automated screening and centralized data.",
							},
							{
								icon: <Fairness />,
								title: "Fairness",
								description: "Minimize bias by standardizing and streamlining every step of the hiring process.",
							},
							{
								icon: <Growth />,
								title: "Growth",
								description:
									"Connect top talent with leading companies to drive success on both sides of the hiring equation.",
							},
						].map((item, index) => {
							return (
								<div key={index} className="p-8 rounded-lg shadow flex-1">
									<div className="space-y-2.5">
										<div className="flex items-center gap-2.5">
											{item.icon}
											<div className="text-xl font-semibold">{item.title}</div>
										</div>
										<div className="text-lg font-medium text-[#555555]">{item.description}</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="py-8">
				<div className="container max-w-[1243px]">
					<div className="space-y-2 py-8">
						<div className="text-center text-[34px] font-bold text-[#007BFF]">Our Vision</div>
						<div className="text-center text-2xl font-normal text-[#555555]">
							To become Tanzania’s leading job destination marketplace by revolutionizing recruitment into a fast,
							data-driven, and transparent process that works for everyone.
						</div>
					</div>
				</div>
			</div>
			<div className="bg-white pt-24 pb-16">
				<div className="container max-w-[1243px] space-y-4">
					<h2 className="text-[36px] font-bold text-center">What You Can Do Today</h2>
					<div className="flex flex-col md:flex-row gap-6">
						{[
							{
								icon: <TailoredJob />,
								title: "Job Seekers",
								description:
									"Set your preferences on Dproz. Let the system know what kinds of jobs you are looking for so we can recommend opportunities that match.",
								action: {
									link: "/register",
									type: "internal",
								},
							},
							{
								icon: <AIPowered />,
								title: "Employers and Recruiters",
								description:
									"Post your jobs on Dproz. Our reach and tools are designed for Tanzania. Make your roles visible to more qualified candidates — not just your inbox or LinkedIn.",
								action: {
									link: "https://hiring.dproz.com/signup",
									type: "external",
								},
							},
							{
								icon: <OneClick />,
								title: "Everyone",
								description:
									"If you see a job that others could benefit from, share it with us. We will verify and recommend it to the right people.",
							},
						].map((item, index) => {
							return (
								<div key={index} className="flex flex-col justify-between gap-6 p-8 rounded-lg shadow flex-1">
									<div className="space-y-2.5">
										<div className="flex items-center gap-2.5">
											{item.icon}
											<div className="text-xl font-semibold">{item.title}</div>
										</div>
										<div className="text-lg font-medium text-[#555555]">{item.description}</div>
									</div>
									{item.action && (
										<Button
											className="rounded-lg w-full"
											onClick={() => {
												if (item.action.type === "external") {
													window.open(item.action.link, "_blank");
												} else {
													navigate(item.action.link);
												}
											}}
										>
											Get Started
										</Button>
									)}
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<section className="bg-gray-900 pt-24 pb-16 px-4 md:px-8">
				<div className="max-w-4xl mx-auto text-center">
					<h2 className="text-3xl md:text-4xl font-bold mb-4 text-white font-plus-jakarta">Join the Movement</h2>
					<p className="text-xl text-gray-400 opacity-80 mb-8 font-inter">
						Let us make job access open and fair for every young Tanzanian. Let us build careers, skills, and a future
						that includes everyone.
						<br />
						<br />
						One step at a time. One opportunity at a time.
					</p>
					<Button
						className="rounded-lg"
						onClick={() => {
							navigate("/register");
						}}
					>
						Join us today
					</Button>
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default AboutUsNewDesign;
